import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { DataProvider } from '@/components/context/DataProvider';
import { VerifyBusinessSummaryEntry } from '@/components/molecules/VerifyBusinessSummaryEntry';
import { Field, FieldType, ListField, ValueType } from '@/types/fields';

interface Props {
  readonly value: ValueType | undefined;
  readonly field: ListField<unknown>;
}
export const ListFieldValueRenderer: React.FC<Props> = (props: Props): React.ReactNode => {
  const { value, field } = props;
  const { fields } = field;

  if (!value || fields.length === 0) {
    return <></>;
  } else if (!Array.isArray(value)) {
    console.debug('list field has a non-array value', value);
    return <></>;
  }

  return value.map((item: Record<string, unknown>, index: number): React.ReactNode => {
    const itemId = typeof item.id === 'string' ? item.id : String(index);

    return (
      <React.Fragment key={itemId}>
        {fields.length > 1 ? (
          <Box position="sticky" top={0} bgcolor="background.paper">
            <Typography variant="body2" color="primary.main">
              {field.title} #{index + 1}
            </Typography>
          </Box>
        ) : (
          <></>
        )}

        <DataProvider data={item}>
          <Box display="flex" flexDirection="column" gap={4}>
            {fields.map((fieldTemplate: Field<unknown>): React.ReactNode => {
              if (fieldTemplate.type === FieldType.embedded) {
                const { fields: embeddedFields } = fieldTemplate;

                return embeddedFields.map((fieldTemplate: Field<unknown>): React.ReactNode => {
                  const embeddedFieldValue = item[fieldTemplate.name];
                  const embeddedField = ((): Field<unknown> => {
                    if (fieldTemplate.type === FieldType.file) {
                      const { path } = fieldTemplate;
                      return { ...fieldTemplate, path: path.replace('{id}', itemId) };
                    } else {
                      return fieldTemplate;
                    }
                  })();

                  return (
                    <VerifyBusinessSummaryEntry
                      key={embeddedField.name}
                      field={embeddedField}
                      value={embeddedFieldValue}
                    />
                  );
                });
              } else {
                const field = ((): Field<unknown> => {
                  if (fieldTemplate.type === FieldType.file) {
                    const { path } = fieldTemplate;
                    return { ...fieldTemplate, path: path.replace('{id}', itemId) };
                  } else {
                    return fieldTemplate;
                  }
                })();

                return (
                  <VerifyBusinessSummaryEntry
                    key={field.name}
                    field={field}
                    value={item[field.name]}
                  />
                );
              }
            })}
          </Box>
        </DataProvider>
      </React.Fragment>
    );
  });
};
